<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
      <v-row
        class="pa-4"
      >
        <v-col
          class="py-0 my-0"
        />
        <v-btn
          class="ma-2"
          outlined
          color="indigo"
          @click="volverDeVerificarDireccion"
        >
        <v-icon dark>
              mdi-arrow-left
            </v-icon>
          Regresar
        </v-btn>
      </v-row>

        <v-card>
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="submit()"
        >
          <base-material-card
            icon="mdi-clipboard-text-outline"
            title="Prospeccion"
            class="px-5 py-3"
          >

            <v-divider></v-divider>
        <v-row>
          <v-col
            lg="6"
          >
            <v-card-title>
              Medio de Contacto
            </v-card-title>
            <v-select
            v-model="medioDeContactoSeleccionado"
            class="px-2 py-1"
            outlined
            flat
            :items="medioDeContactos"
            label="Medio de Contacto"
            :rules="[v => !!v || 'El medio de contacto es obligatorio']"
            required
          />
          </v-col>
          <v-col
            lg="6"
          >
              <v-card-title>
              Estado de Contacto
            </v-card-title>

          <v-select
            v-model="estadoDeContactoSeleccionado"
            class="px-2 py-1"
            outlined
            flat
            :items="estadosDeContacto"
            label="Estado de contacto"
            :rules="[v => !!v || 'El estado de contacto es obligatorio']"
            required
          />
          </v-col>
        </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </base-material-card>

        </v-form>
      </v-card>

      <v-card>
        <v-form
          ref="formVerificarDireccion"
          lazy-validation
          @submit.prevent="save()"
        >
          <base-material-card
            icon="mdi-map-marker"
            title="Confirmar ubicación"
            class="px-5 py-3"
          >
            <v-card-title>
              Dirección fiscal
            </v-card-title>
            <v-card-text>

              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model="departamentoFiscal"
                    outlined
                    :items="departamentos"
                    label="Seleccione la region"
                    @change="onChangeRegionFiscal"
                  ></v-select>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="provinciaFiscal"
                    outlined
                    :items="provinciasFiscal"
                    label="Seleccione la provincia (Excepto region Lima, Seleccione distrito)"
                  ></v-select>
                </v-col>
              </v-row>

              <v-text-field
                v-model="direccionFiscal"
                class="my-2"
                label="Direccion fiscal"
                hide-details
                outlined
                required
              />

              <v-btn
              v-if="existeFotoFiscal"
                color="primary"
                class="mx-2"
                @click="subirFotoFiscal"
              >
                Subir foto
              </v-btn>

              <v-btn
                v-if="!existeFotoFiscal"
                outlined
                class="mx-2"
                @click="subirFotoFiscal"
              >
                Subir foto
              </v-btn>

              <v-btn
                v-if="isVerificadoDireccionFiscalGPS"
                color="primary"
                @click="openDireccionFiscal"
              >
                Direccion gps
              </v-btn>

              <v-btn
                v-else
                outlined
                @click="openDireccionFiscal"
              >
                Direccion gps
              </v-btn>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-title>
              Dirección real
            </v-card-title>

            <v-card-text>

              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model="departamentoReal"
                    outlined
                    flat
                    :items="departamentos"
                    label="Seleccione la region"
                    @change="onChangeRegionReal"
                  />
                </v-col>

                <v-col cols="6">
                <v-select
                  v-model="provinciaReal"
                  outlined
                  flat
                  :items="provinciasReal"
                  label="Seleccione la provincia (Excepto region Lima, Seleccione distrito)"
                />
                </v-col>
              </v-row>

              <v-text-field
                v-model="direccionReal"
                class="my-2"
                flat
                label="Direccion Real"
                hide-details
                outlined
              />

              <v-btn
                v-if="existeFotoReal"
                color="primary"
                class="mx-2"
                @click="subirFotoReal"
              >
                Subir Foto
              </v-btn>

              <v-btn
                v-if="!existeFotoReal"
                outlined
                class="mx-2"
                @click="subirFotoReal"
              >
                Subir Foto
              </v-btn>

              <v-btn
                v-if="isVerificadoDireccionRealGPS"
                :disabled="isValidVerificarDireccionReal"
                color="primary"
                @click="openDireccionReal"
              >
                Direccion gps
              </v-btn>
              
              <v-btn
                v-else
                :disabled="isValidVerificarDireccionReal"
                outlined
                @click="openDireccionReal"
              >
                Direccion gps
              </v-btn>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </base-material-card>

        </v-form>
      </v-card>
    </v-container>

    <view-map-component
      ref="viewMapFiscal"
      @changeCoordinates="changeCoordinatesFiscal"
    />

    <view-map-component
      ref="viewMapReal"
      @changeCoordinates="changeCoordinatesReal"
    />

    <wait-gps-component
    :dialog-wait-gps="dialogWaitGps"
    >
    </wait-gps-component>

    <dialog-upload
      ref="uploadFileFiscal"
      @onUploadFiscal="onUploadFiscal"
    />
     <dialog-upload
      ref="uploadFileReal"
      @onUploadReal="onUploadReal"
    />

  </div>
</template>

<script>
  import ViewMapComponent from './ViewMapComponent.vue'
  import WaitGpsComponent from './components/WaitGpsComponent.vue'
  import DialogUpload from './components/dialogUploadComponent.vue'

  // import firebase from 'firebase'
  import 'firebase/storage'

  // const db = firebase.firestore()

  export default {
    components: {
      ViewMapComponent,
      WaitGpsComponent,
      DialogUpload,
    },
    data () {
      return {
        item: {},
        medioDeContactoSeleccionado: '',
        medioDeContactos: [],
        estadoDeContactoSeleccionado: '',
        estadosDeContacto: [],
        loadingFoto: false,
        fotoDireccionFiscalUri: '',
        fotoDireccionRealUri: '',
        dialogWaitGps: false,
        direccionFiscal: '',
        direccionReal: '',
        dialog: false,
        loading: false,
        coordinatesFiscal: {
          Latitude: 0,
          Longitude: 0,
        },
        verificadoDireccionFiscalGPS: false,
        coordinatesReal: {
          Latitude: 0,
          Longitude: 0,
        },
        verificadoDireccionRealGPS: false,
        zoomMap: 13,
        departamentoFiscal: '',
        departamentos: [],
        provinciaFiscal: '',
        provinciasFiscal: [],
        provinciasReal: [],
        departamentoReal: '',
        provinciaReal: '',
      }
    },
    computed: {
      existeFotoFiscal: function () {
        return this.item?.foto_direccion_fiscal
      },
      existeFotoReal: function () {
        return this.item?.foto_direccion_real
      },
      isVerificadoDireccionFiscalGPS: function () {
        return this.verificadoDireccionFiscalGPS !== '0'
      },
      isVerificadoDireccionRealGPS: function () {
        return this.verificadoDireccionRealGPS !== '0'
      },
      isValidVerificarDireccionReal: function () {
        return this.direccionReal === ''
      }
    },
    mounted () {
      this.existeItem()
      this.medioDeContactos = this.$store.state.medioDeContactoEntidadTecnica
      this.estadosDeContacto = this.$store.state.estadoDeContactoEntidadTecnicaDeConvocatoria
      this.getDepartamentos()
    },
    methods: {
      async save () {
        if (this.$refs.formVerificarDireccion.validate()) {
          this.loading = true
          
          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.item.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            latitud_fiscal_gps: this.coordinatesFiscal.Latitude || '',
            longitud_fiscal_gps: this.coordinatesFiscal.Longitude || '', 
            direccion_fiscal: this.direccionFiscal || '',
            direccion_real: this.direccionReal || '',
            departamento_fiscal: this.departamentoFiscal || '',
            provincia_fiscal: this.provinciaFiscal || '',
            departamento_real: this.departamentoReal || '',
            provincia_real: this.provinciaReal || '',
            latitud_real_gps: this.coordinatesReal.Latitude || '',
            longitud_real_gps: this.coordinatesReal.Longitude || '',
            verificado_direccion_fiscal_gps: this.verificadoDireccionFiscalGPS || '',
            verificado_direccion_real_gps: this.verificadoDireccionRealGPS || '',
            })
          })
          const data = await response.json()
          if (data.success) {}

          this.loading = false
          if (this.$route.params.isConvocatoria) {
            this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
          } else {
            this.$router.push({ name: 'Entidades Tecnicas' })
          }
        }
      },
      async existeItem () {
        if (!this.$route.params.item) {
          this.$router.push({ name: 'Entidades Tecnicas' })
        } else {
          this.item = this.$route.params.item
          this.coordinatesFiscal.Latitude = this.item?.latitud_fiscal_gps
          this.coordinatesFiscal.Longitude = this.item?.longitud_fiscal_gps
          this.coordinatesReal.Latitude = this.item?.latitud_real_gps
          this.coordinatesReal.Longitude = this.item?.longitud_real_gps
          this.direccionFiscal = this.item?.direccion_fiscal
          this.direccionReal = this.item?.direccion_real
          this.verificadoDireccionFiscalGPS = this.item?.verificado_direccion_fiscal_gps
          this.verificadoDireccionRealGPS = this.item?.verificado_direccion_real_gps

          this.medioDeContactoSeleccionado = this.item.medio_de_contacto ? this.item.medio_de_contacto : ''
          this.estadoDeContactoSeleccionado = this.item.estado ? this.item.estado : ''

          if (this.item?.departamento_fiscal) {
            this.departamentoFiscal = await this.item?.departamento_fiscal || ''
            if (this.departamentoFiscal) {
              await this.onChangeRegionFiscal()
            }
            this.provinciaFiscal = this.item?.provincia_fiscal || ''
          }

          if (this.item?.departamento_real) {
            this.departamentoReal = await this.item?.departamento_real || ''
            if (this.departamentoReal) {
              await this.onChangeRegionReal()
            }
            this.provinciaReal = this.item?.provincia_real || ''
          }
        }
      },
      openDireccionFiscal () {
        this.dialogWaitGps = true
        if (!this.item?.latitud_fiscal_gps || this.item?.longitud_fiscal_gps === '0') {
          this.$getLocation().then(coordinates => {
            let Latitude = 0
            let Longitude = 0
            Latitude = coordinates.lat
            Longitude = coordinates.lng
            this.$refs.viewMapFiscal.open({ Latitude: Latitude, Longitude: Longitude })
            this.dialogWaitGps = false
          })
        } else {
            this.$refs.viewMapFiscal.open({ Latitude: this.item.latitud_fiscal_gps, Longitude: this.item.longitud_fiscal_gps })
            this.dialogWaitGps = false
        }
      },
      openDireccionReal () {
        this.dialogWaitGps = true
        if (!this.item?.longitud_real_gps || this.item?.longitud_real_gps === '0') {
          this.$getLocation().then(coordinates => {
            let Latitude = 0
            let Longitude = 0
            Latitude = coordinates.lat
            Longitude = coordinates.lng
            this.$refs.viewMapReal.open({ Latitude: Latitude, Longitude: Longitude })
            this.dialogWaitGps = false
          })
        } else {
            this.$refs.viewMapReal.open({ Latitude: this.item.latitud_real_gps, Longitude: this.item.longitud_real_gps })
            this.dialogWaitGps = false
        }
      },
      changeCoordinatesFiscal (coordinates) {
        if (coordinates) {
          this.coordinatesFiscal.Latitude = coordinates.lat
          this.coordinatesFiscal.Longitude = coordinates.lng
          this.verificadoDireccionFiscalGPS = true
        } else {
          this.coordinatesFiscal.Latitude = this.item.latitud_fiscal_gps
          this.coordinatesFiscal.Longitude = this.item.longitud_fiscal_gps
          this.verificadoDireccionFiscalGPS = false
        }
      },
      changeCoordinatesReal (coordinates) {
        if (coordinates) {
          this.coordinatesReal.Latitude = coordinates.lat
          this.coordinatesReal.Longitude = coordinates.lng
          this.verificadoDireccionRealGPS = true
        } else {
          this.coordinatesReal.Latitude = this.item.latitud_real_gps
          this.coordinatesReal.Longitude = this.item.longitud_real_gps
          this.verificadoDireccionRealGPS = false
        }
      },
      async subirFotoFiscal (e) {
        const newItem = {
          id: this.item.id,
          foto: this.item?.foto_direccion_fiscal
        }
        this.$refs.uploadFileFiscal.open(newItem, 'Fiscal')
      },
      onUploadFiscal (fotoFiscal) {
        this.item.foto_direccion_fiscal = fotoFiscal
      },
      async subirFotoReal (e) {
        const newItem = {
          id: this.item.id,
          foto: this.item?.foto_direccion_real
        }
        this.$refs.uploadFileReal.open(newItem, 'Real')
      },
      onUploadReal (fotoReal) {
        this.item.foto_direccion_real = fotoReal
      },
      volverDeVerificarDireccion () {
        if (this.$route.params.isConvocatoria) {
          this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
        } else {
          this.$router.push({ name: 'Entidades Tecnicas' })
        }
      },
      async submit () {
        if (this.$refs.form.validate()) {
          this.loading = true
          // db.collection('EntidadesTecnicas').doc(this.item.id).set({
          //   medioDeContacto: this.medioDeContactoSeleccionado,
          //   estado: this.estadoDeContactoSeleccionado,
          // }, { merge: true }).then(() => {
          //   this.loading = false
          //     if (this.$route.params.isConvocatoria) {
          //       this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
          //     } else {
          //       this.$router.push({ name: 'Entidades Tecnicas' })
          //     }
          //   // this.$router.go(-1)
          // })

            // medioDeContacto: this.medioDeContactoSeleccionado,
            // estado: this.estadoDeContactoSeleccionado,

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.item.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              medio_de_contacto: this.medioDeContactoSeleccionado,
              estado: this.estadoDeContactoSeleccionado,
            })
          })
          const data = await response.json()
          if (data.success) {}
      
          this.loading = false
          if (this.$route.params.isConvocatoria) {
            this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
          } else {
            this.$router.push({ name: 'Entidades Tecnicas' })
          }
        }
      },
      getDepartamentos () {
        this.departamentos = []
        this.$store.state.regiones.forEach(region => {
          this.departamentos.push(region.NOMBRE)
        })
      },
      onChangeRegionFiscal () {
        var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamentoFiscal)
        this.provinciasFiscal = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
      },
      onChangeRegionReal () {
        var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamentoReal)
        this.provinciasReal = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
      },
    },
  }
</script>
